/*
 * Copyright (c) 2021 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import DomainApplicationView from './DomainApplicationView';
import institutions from '../institutions';
import applications from '../applications';
import {navigateToApplication} from './state';

export class DomainApplicationViewContainer extends Component {

  static propTypes = {

      institution: PropTypes.object,
      institutions: PropTypes.array,

      fetchApplications: PropTypes.func.isRequired,
      fetchInstitutions: PropTypes.func.isRequired,
      changeContextInstitution: PropTypes.func.isRequired
    };

    render () {
      return (
        <DomainApplicationView onChangeContextInstitution={this.props.changeContextInstitution}
          {...this.props} />
      );
    }

    componentDidMount () {
      this.props.fetchApplications();
      this.props.fetchInstitutions();
      if (this.props.contextInstitutionId && ! this.props.institution) {
        this.props.fetchInstitution(this.props.contextInstitutionId);
      }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.institution !== this.props.institution &&
            prevProps.institutions.length !== this.props.institutions.length &&
            this.props.institutions.length === 1) {
            this.props.changeContextInstitution(this.props.institutions[0]);
        }
    }
}

/**
 * Map state from the Redux store to properties on the component.
 *
 * @param state state from the redux store.
 */
const mapStateToProps = (state) => {
  return {
    institutions: institutions.selectors.getInstitutionsSortedByName(state),
    institution:  institutions.selectors.getContextInstitution(state),
    contextInstitutionId: institutions.selectors.getContextInstitutionId(state)
  };
};

const mapDispatchToProps = dispatch => ({

  fetchInstitution: bindActionCreators(institutions.actions.fetchInstitution, dispatch),
  fetchInstitutions: bindActionCreators(institutions.actions.fetchInstitutions, dispatch),
  fetchApplications: bindActionCreators(applications.actions.fetchApplications, dispatch),
  changeContextInstitution: (institution) => {
    updateContextInstitution(institution, dispatch).finally(() => {
      dispatch(applications.actions.fetchApplications());
      dispatch(navigateToApplication());
    })
  }
});

/**
 * Update the context institution
 *
 * @param institution
 * @param dispatch
 * @returns {Promise<>} promise object
 */
const updateContextInstitution = (institution, dispatch) => new Promise((resolve) => {
    dispatch(institutions.actions.changeContextInstitution(institution));
    resolve();
});

export default connect(mapStateToProps, mapDispatchToProps)(DomainApplicationViewContainer);



// WEBPACK FOOTER //
// ./src/DomainApplicationView/DomainApplicationViewContainer.js